<form [formGroup]="emailForm" class="delete-account-form" data-testid="delete-account-form">
    <div>
        <div class="info-text">{{ subtitle(1931) }}</div>
        <form-email-input
            data-testid="delete-account-email"
            [emailControl]="emailControl">
        </form-email-input>
    </div>
    <form-action-buttons>
        <form-button [subtitle]="subtitle(71)"
                     [btnType]="'cancel'"
                     (click)="closeForm()">
        </form-button>
        <form-button [subtitle]="subtitle(3806)"
                     [btnType]="'danger'"
                     (click)="deleteAccount()">
        </form-button>
    </form-action-buttons>
</form>